export default __webpack_public_path__ + "551c1a6ce835d18f163a1d582882dfb6.svg";